import {$Container, ContainerProps, JSX, SpecialProps, CanBeSignal, getProp, patchEvents} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {Override} from '@gongxigames/framework/lib/types/basic';
import {
    StateContainer as StateContainerConstructor,
    StateContainerHooks,
    StateContainerStatesConfig,
} from '@gongxigames/framework/core/fragments/display/StateContainer';

type BaseStateContainerProps<S extends string, D> = {
    children?: JSX.Element | ((instance: StateContainerConstructor<S, D>) => JSX.Element);
    initState: S;
    states: StateContainerStatesConfig<S>;
    data?: D;
    transitions?: StateContainerHooks<S, D>;
    toState?: CanBeSignal<S>;
};

export type StateContainerProps<S extends string, D>
    = Override<ContainerProps, BaseStateContainerProps<S, D> & SpecialProps<StateContainerConstructor<S, D>>>;

export function $StateContainer<S extends string, D>(props: StateContainerProps<S, D>): StateContainerConstructor<S, D> {
    const instance = props.instance ??= new StateContainerConstructor(
        props.initState,
        props.states,
        props.data,
    );

    if (props.transitions) {
        instance.onTransitions(props.transitions);
    }

    props.events ??= {};

    if (props.toState) {
        const off = Store.effect(() => {
            const toState = getProp(props.toState);

            instance.setState(toState as S);
        });

        patchEvents(props.events, {destroyed: off});
    }

    if (typeof props.children === 'function') {
        props.children = props.children(instance);
    }

    const result = $Container(props as ContainerProps) as StateContainerConstructor<S, D>

    result.setState(props.initState);

    return result;
};